import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingGuardService, LoginRouteGuardService } from './app-routing-guard.service';

const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    canActivate: [LoginRouteGuardService]
  },
  {
    path: 'login/resetPassword',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    canActivate: [LoginRouteGuardService]
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [AppRoutingGuardService]
  },
  {
    path: 'user-list',
    loadComponent: () => import('./user-list/user-list.component').then(m => m.UserListComponent),
    canActivate: [AppRoutingGuardService]
  },
  {
    path: 'mission-list',
    loadComponent: () => import('./job-list/job-list.component').then(m => m.JobListComponent),
    children: [
      {
        path: ':id',
        loadComponent: () => import('./job-list/job/job.component').then(m => m.JobComponent)
      }
    ],
    canActivate: [AppRoutingGuardService]
  },
  {
    path: 'device-list',
    loadComponent: () => import('./device-list/device-list.component').then(m => m.DeviceListComponent),
    children: [
      {
        path: ':id',
        loadComponent: () => import('./device-list/device/device.component').then(m => m.DeviceComponent)
      }
    ],
    canActivate: [AppRoutingGuardService]
  },
  {
    path: 'device-alarm-list',
    loadComponent: () => import('./device-alarm-list/device-alarm-list.component').then(m => m.DeviceAlarmListComponent),
    children: [
      {
        path: 'notification-settings',
        loadComponent: () => import('./device-alarm-list/device-notification-settings/device-notification-settings.component').then(m => m.DeviceNotificationSettingsComponent)
      }
    ],
    canActivate: [AppRoutingGuardService]
  },
  {
    path: 'user-profile',
    loadComponent: () => import('./user-profile/user-profile.component').then(m => m.UserProfileComponent),
    canActivate: [AppRoutingGuardService]
  },
  {
    path: 'mission-data/:id',
    loadComponent: () => import('./job-data/job-data.component').then(m => m.JobDataComponent),
    children: [
      {
        path: 'position',
        loadComponent: () => import('./job-data/position/position.component').then(m => m.PositionComponent)
      },
      {
        path: 'analysis',
        loadComponent: () => import('./job-data/analysis/analysis.component').then(m => m.AnalysisComponent)
      }
    ],
    canActivate: [AppRoutingGuardService]
  },
  {
    path: 'role-list',
    loadComponent: () => import('./role-list/role-list.component').then(m => m.RoleListComponent),
    canActivate: [AppRoutingGuardService]
  },
  {
    path: 'system-config',
    loadComponent: () => import('./system-config/system-config.component').then(m => m.SystemConfigComponent),
    children: [
      {
        path: '',
        redirectTo: 'settings',
        pathMatch: 'full'
      },
      {
        path: 'settings',
        loadComponent: () => import('./system-config/settings/settings.component').then(m => m.SettingsComponent)
      },
      {
        path: 'database',
        loadComponent: () => import('./system-config/database/database.component').then(m => m.DatabaseComponent),
        children: [
        {
          path: '',
          redirectTo: 'last-activities',
          pathMatch: 'full'
        },
        {
          path: 'last-activities',
          loadComponent: () => import('./system-config/database/last-activities/last-activities.component').then(x => x.LastActivitiesComponent)
        },
        {
            path: 'device-records',
            loadComponent: () => import('./system-config/database/device-records/device-records.component').then(x => x.DeviceRecordsComponent)
        },
        {
            path: 'tracking-server',
            loadComponent: () => import('./system-config/database/tracking-server/tracking-server.component').then(x => x.TrackingServerComponent)
          }
      ]
      },
      {
        path: 'encryption',
        loadComponent: () => import('./system-config/encryption/encryption.component').then(m => m.EncryptionComponent)
      }
    ],
    canActivate: [AppRoutingGuardService]
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AppRoutingGuardService, LoginRouteGuardService]

})
export class AppRoutingModule { }